import React from "react";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../../constant/api";

function SquareImageCard({ data, title, bg }) {
  return (
    <>
      <h1 className="mx-10 text-2xl font-bold">{title}</h1>
      <div className="overflow-x-auto p-4">
        <div className="flex gap-4 md:gap-5">
          {data.map((d) => (
            <Link to={`/nearest_suppliers/${d.seller_id}`}>
              <div
                key={d.seller_id}
                className={`flex h-40 w-40 flex-col items-center justify-center border-2 shadow-lg sm:h-64 sm:w-64 ${bg} p-5`} // Default size for small devices, larger size for sm and above
              >
                <div className="h-32 w-32 p-4 sm:h-52 sm:w-52">
                  <img
                    src={
                      d.logo
                        ? d.logo.startsWith(BASE_URL)
                          ? d.logo
                          : `${BASE_URL}${d.logo}`
                        : "https://via.placeholder.com/100"
                    }
                    alt={d.name}
                    className="w-full" // Adjust image size accordingly
                  />
                </div>
                <span className="text-center text-sm font-bold">{d.name}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}

export default SquareImageCard;
